import { render } from "./SupportMeasures.vue?vue&type=template&id=b0a161e8&scoped=true"
import script from "./SupportMeasures.vue?vue&type=script&lang=js"
export * from "./SupportMeasures.vue?vue&type=script&lang=js"

import "./SupportMeasures.vue?vue&type=style&index=0&id=b0a161e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a161e8"]])

export default __exports__